<div class="stepper d-flex">
	<div
		class="step"
		*ngFor="let step of routes; let i = index"
		[ngClass]="{
			active: i <= currentPathIndex,
			clickable: i <= currentPathIndex,
			disabled: i > currentPathIndex
		}"
		[attr.title]=""
		[routerLink]="routes[i].route"
		[queryParams]="queryParams"
	>
		<a
			class="step-title text-align-left padding-top-10 text-14"
			[ngClass]="{
				current: i === currentPathIndex
			}"
			>{{ routes[i].label }}</a
		>
	</div>
</div>
